$( document ).ready( function() {
    if ($('#selectedCountryHeroBanner').length > 0) {
        $('.js-country-item').click(function() {
            let name = $(this).data('name');
            $('.js-country-item').removeClass('active');
            $(this).addClass('active');
            $('.js-country-selected').text(name);
        });

        $('.js-country-btn').click(function() {
            let url = $('.js-country-item.active').data('url');
            location.href = url;
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/components/selected-country-hero-banner.js